import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router/index'
import 'vant/lib/index.css';
import { Swipe, SwipeItem } from 'vant';
import tc from "./components/login.vue"


const app = createApp(App)
app.use(router).use().use(Swipe).use(SwipeItem)

app.component('tc', tc)

app.mount('#app')



window.onload = function() {

    (function() {
        if (
            typeof WeixinJSBridge == "object" &&
            typeof WeixinJSBridge.invoke == "function"
        ) {
            handleFontSize();
        } else {
            if (document.addEventListener) {
                document.addEventListener("WeixinJSBridgeReady", handleFontSize, false);
            } else if (document.attachEvent) {
                document.attachEvent("WeixinJSBridgeReady", handleFontSize);
                document.attachEvent("onWeixinJSBridgeReady", handleFontSize);
            }
        }

        function handleFontSize() {
            // 设置网页字体为默认大小
            WeixinJSBridge.invoke("setFontSizeCallback", { fontSize: 0 });
            // 重写设置网页字体大小的事件
            WeixinJSBridge.on("menu:setfont", function() {
                WeixinJSBridge.invoke("setFontSizeCallback", { fontSize: 0 });
            });
        }
    })()

    // 禁用双指放大
    document.addEventListener('touchstart', function(event) {
        if (event.touches.length > 1) {
            event.preventDefault()
        }
    });
    document.addEventListener('gesturestart', function(event) {
            event.preventDefault()
        })
        // 禁用双击放大
    var lastTouchEnd = 0;
    document.documentElement.addEventListener('touchend', function(event) {
        var now = Date.now();
        if (now - lastTouchEnd <= 300) {
            event.preventDefault();
        }
        lastTouchEnd = now;
    }, {
        passive: false
    });
}
window.alert = function(name) {
    var iframe = document.createElement("IFRAME");
    iframe.style.display = "none";
    iframe.setAttribute("src", 'data:text/plain');
    document.documentElement.appendChild(iframe);
    window.frames[0].window.alert(name);
    iframe.parentNode.removeChild(iframe);
}